import copy from 'copy-to-clipboard';

/**
 * Copies `text`, through the clipboard API where the page has one and it allows the copy. A page served
 * over plain HTTP (not localhost) has none, so there `copy-to-clipboard` selects the text without focusing
 * it, which works inside a dialog's or menu's focus trap, and as a last resort shows it to copy by hand.
 * Rejects when nothing copies, with the clipboard API's refusal as the cause.
 */
export const copyText = async (text: string): Promise<void> => {
  let refusal: unknown;
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (error) {
      // An iframe without clipboard-write, or a browser that wants a fresher click: try the other way.
      refusal = error;
    }
  }
  if (!copy(text, { format: 'text/plain' })) {
    throw new Error('Could not copy to the clipboard', { cause: refusal });
  }
};
